import React, { useEffect, useState } from 'react';
import { FiCreditCard, FiEdit3, FiLogIn } from 'react-icons/fi';
import { useApi } from '../../useApi';
import { describeTimelineItem, formatWhen } from './adminFormat';
import './AdminInsights.css';

/* One user's sign-ins, subscription events and hand-made plan changes, newest
   first. Opened from a user card on the admin dashboard; system admin only. */

const ICONS = { login: FiLogIn, subscription: FiCreditCard, plan_change: FiEdit3 };
const PAGE_SIZE = 25;

export default function UserTimeline({ userId }) {
  const { authenticatedFetch } = useApi();
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const [shown, setShown] = useState(PAGE_SIZE);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authenticatedFetch(`/admin/users/${userId}/timeline`);
        if (!res.ok) throw new Error();
        const data = await res.json();
        if (!cancelled) setItems(data.items || []);
      } catch {
        if (!cancelled) setError('Could not load this user’s activity.');
      }
    })();
    return () => { cancelled = true; };
  }, [authenticatedFetch, userId]);

  if (error) return <p className="ai-error">{error}</p>;
  if (items === null) return <p className="ai-empty">Loading activity…</p>;
  if (items.length === 0) {
    return (
      <p className="ai-empty">
        Nothing recorded yet. Sign-ins and subscription events are kept from the release that added them.
      </p>
    );
  }

  return (
    <div className="ut">
      <ul className="ai-list ut-list">
        {items.slice(0, shown).map((item, i) => {
          const Icon = ICONS[item.kind] || FiLogIn;
          const { title, detail } = describeTimelineItem(item);
          return (
            <li key={`${item.kind}-${item.at}-${i}`}>
              <span className={`ut-icon ut-icon--${item.kind}`}><Icon size={14} /></span>
              <span className="ai-list-main">
                <span className="ai-list-title">{title}</span>
                {detail && <span className="ai-list-detail">{detail}</span>}
              </span>
              <span className="ai-list-when">{formatWhen(item.at)}</span>
            </li>
          );
        })}
      </ul>
      {items.length > shown && (
        <button className="ai-btn ai-btn--quiet ut-more" onClick={() => setShown((n) => n + PAGE_SIZE)}>
          Show more ({items.length - shown})
        </button>
      )}
    </div>
  );
}
